// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ExternalClaimAccumulatorModel {
    'startDate'?: Moment | null;
    'endDate'?: Moment | null;
    'balance'?: number;
    'availableBalance'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ExternalClaimAccumulatorModel>> = [
        {
            "name":     "startDate",
            "baseName": "startDate",
            "type":     "Date"
        },
        {
            "name":     "endDate",
            "baseName": "endDate",
            "type":     "Date"
        },
        {
            "name":     "balance",
            "baseName": "balance",
            "type":     "number"
        },
        {
            "name":     "availableBalance",
            "baseName": "availableBalance",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return ExternalClaimAccumulatorModel.attributeTypeMap;
    }
}
